<template>
  <div>
    <v-breadcrumbs
      class="pt-3 pl-7"
      :items="[{ text: 'Families', exact: true,  to: { name: 'colors' } }, { text: oldFamily.name }]"
    >
    </v-breadcrumbs>
    <v-row
      class="mt-0"
    >

      <v-col
        cols="12"
        md="5"
      >

        <v-card
          flat
          class="mx-3 pb-9"
        >
          <v-toolbar
            dark
            class="tertiary"
            dense
            elevation="0"
          >
            <v-toolbar-title>Color Family</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click="editFamilyClick()"
              :disabled="!user.can('color-family.update')"
            >
              <v-icon color="secondary" small>fas fa-edit</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text>

            <dl class="row table mt-5">
              <dt class="col-5">Code:</dt>
              <dd class="col-7">{{ oldFamily.code }}</dd>

              <dt class="col-5">Name:</dt>
              <dd class="col-7">{{ oldFamily.name }}</dd>

              <dt class="col-5">Active:</dt>
              <dd class="col-7"><v-icon :color="oldFamily.is_active ? 'secondary' : 'grey'" x-small>fas fa-circle</v-icon></dd>

            </dl>

          </v-card-text>

          <color-family-dialog
            v-model="familyDialog"
            :attributes="family"
            :errors="familyErrors"
            @save="saveFamilyClick()"
          ></color-family-dialog>

        </v-card>


      </v-col>


      <v-col
        cols="12"
        md="7"
      >
        <v-card
          flat
          class="mx-3 pb-9"
        >
          <v-toolbar
            dark
            class="tertiary"
            dense
            elevation="0"
          >
            <v-toolbar-title>Colors</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
              dense
              background-color="primary"
              v-model="filter.query"
              label="Search..."
              single-line
              hide-details
              solo
              @keyup="searchKeyUp()"
            ></v-text-field>
            <v-btn
              icon
              color="secondary"
              @click="newColorClick()"
              :disabled="!user.can('color.update')"
            >
              <v-icon small>fas fa-plus</v-icon>
            </v-btn>
          </v-toolbar>

          <v-data-table
            :class="{ 'mt-5': true, 'clickable': user.can('color.update') }"          
            :headers="colorHeaders"
            :items="colors"
            :loading="isSearching"
            :options.sync="options"
            :server-items-length="totalCount"
            :footer-props="{ 'items-per-page-options': [5, 10, 50] }"
            @click:row="rowColorClick"
          >
          </v-data-table>

          <color-dialog
            v-model="colorDialog"
            :attributes="color"
            :errors="colorErrors"
            :families="families"
            @save="saveColorClick()"
          ></color-dialog>

        </v-card>
      </v-col>
    </v-row>


  </div>
</template>

<script>
import { inject, ref, watch } from 'vue'
import ColorFamilyDialog from '@/components/ColorFamilyDialog'
import ColorDialog from '@/components/ColorDialog'
import { useRouter, useRoute } from 'vue-router/composables'

export default {
  components: {
    ColorFamilyDialog,
    ColorDialog,
  },
  setup() {
    const api = inject('api')
    const { user } = api
    const router = useRouter()
    const route = useRoute()

    const familyModel = api.model('color-families/:id', {
      params: {
      },
    })

    const { attributes: family, errors: familyErrors, oldAttributes: oldFamily } = familyModel
    const familyDialog = ref(false)

    const familyCollection = api.collection('color-families')
    const { items: families } = familyCollection.all()


    function saveFamilyClick() {
      familyModel.save().then(() => {
        familyCollection.all()
        familyDialog.value = false
      })
    }

    const colorCollection = api.collection('colors', {
      params: {
      },
      filter: {
        color_family_id: 'eq',
        query: 'query:code,name,hex_code',
      },
      // store: true,
    })

    const { items: colors, filter, options, totalCount, isSearching } = colorCollection

    const colorHeaders = [
      { text: 'Code', value: 'code', },
      { text: 'Name', value: 'name' },
      { text: 'Hex', value: 'hex_code' },
    ]

    const searchKeyUp = colorCollection.debounceSearch(300)

    const colorModel = api.model('colors/:id')

    const { attributes: color, errors: colorErrors } = colorModel
    const colorDialog = ref(false)

    function newColorClick() {
      colorModel.clear().setAttribute('color_family_id', family.value.id)
      colorDialog.value = true
    }

    function saveColorClick() {
      colorModel.save().then(() => {
        colorCollection.search()
        colorDialog.value = false
      })
    }

    function rowColorClick(item) {
      if (user.can('color.update')) {
        colorModel.clear().populate(item)
        colorDialog.value = true
      }
    }

    function editFamilyClick() {
      familyModel.reset()
      familyDialog.value = true
    }

    watch(() => route, ({ params }) => {
      if (params.id) {
        familyModel.find(params.id).catch(() => {
          router.push({
            name: 'colors',
          })
        })
        colorCollection.setFilter('color_family_id', params.id).search()
      }
    }, { immediate: true })

    return {
      user,
      family,
      familyErrors,
      oldFamily,
      familyDialog,
      editFamilyClick,
      saveFamilyClick,
      colors,
      filter,
      options,
      totalCount,
      isSearching,
      colorHeaders,
      color,
      colorErrors,
      colorDialog,
      newColorClick,
      saveColorClick,
      rowColorClick,
      families,
      searchKeyUp,
    }

  },
}
</script>

<style scoped>

:deep(.v-data-table.clickable table tbody tr:not(.v-data-table__empty-wrapper):hover) {
  cursor: pointer;
}

dl.table dt, dl.table dd {
  padding-top: 2px;
  padding-bottom: 2px;
}


</style>